<div id="download_area">
    <h1>Total Records Found: <span id="download_records">{{dialogConfig.config.total}}</span></h1> 
    <div style="display:none;">
        Total Records Downloaded: <span id="total_records"></span>
        <div class="progress"  id="total_records_progress">
            <div class="progress-bar progress-bar-animate" role="progressbar" aria-valuenow="0"
            aria-valuemin="0" aria-valuemax="100" style="width:0%">
                0% Complete
            </div>
        </div>
    </div><br>
    <h2>Loading....</h2>
    <span>Please don't reload the page or press back button while data is being downloaded</span>
</div>

